import { isEmpty } from '@ember/utils';
import moment from 'moment';
import { SuspensionCategory } from '@linc-technologies/linced-common/enums/suspensions';

export function generatePost(incident) {
  let content = '';
  if (incident.outcome) {
    content += '<strong>Outcome: </strong>' + incident.displayOutcome + '<br>';
  }
  if (incident.type) {
    content += '<strong>Type: </strong>' + incident.displayType + '<br>';
  }
  if (incident.category) {
    content +=
      '<strong>Category: </strong>' + incident.displayCategory + '<br>';
  }
  content += '<strong>Entry Note: </strong>' + incident.get('entryNote');

  if (
    !isEmpty(incident.referredTo) &&
    !isEmpty(incident.referredTo.get('firstName')) &&
    !isEmpty(incident.referredTo.get('lastName'))
  ) {
    content +=
      '<strong>Referred To: </strong>' +
      incident.referredTo.get('fullName') +
      '<br>';
  }

  if (!isEmpty(incident.referralNote)) {
    content += '<strong>Referral Note: </strong>' + incident.referralNote;
  }

  if (incident.outcomeDescription) {
    content +=
      '<strong>Outcome Details: </strong>' + incident.outcomeDescription;
  }

  return content;
}

export function generateSuspensionPost(suspension, props) {
  let content =
    '<strong>Category:</strong> ' +
    SuspensionCategory.getLabel(props.category) +
    '<br>' +
    '<strong>Reason:</strong> ' +
    suspension.displayReason +
    '<br>' +
    '<strong>Active from:</strong> ' +
    moment(props.startDate, 'YYYY-MM-DD').format('dddd, Do MMMM YYYY') +
    ' to ' +
    moment(suspension.displayEndDate, 'YYYY-MM-DD').format(
      'dddd, Do MMMM YYYY',
    ) +
    '<br>';

  if (!isEmpty(suspension.earlyReturnDate)) {
    content +=
      '<br><strong>This suspension was ended before the intended date.</strong><br>' +
      '<strong>Early return date:</strong>' +
      moment(suspension.earlyReturnDate, 'YYYY-MM-DD').format(
        'dddd, Do MMMM YYYY',
      ) +
      '<br><br>';
  }

  if (suspension.immediateThreat) {
    content +=
      '<strong>This student was deemed an immediate risk to the safety of others</strong><br>';
  }

  if (!isEmpty(suspension.description)) {
    content +=
      '<strong>Short Description:</strong><br>' +
      suspension.description +
      '<br>';
  }

  if (!isEmpty(suspension.behaviourDetails)) {
    content +=
      '<strong>Behaviour Details:</strong><br>' +
      suspension.behaviourDetails +
      '<br>';
  }

  if (!isEmpty(suspension.behaviourExpectations)) {
    content +=
      '<strong>Behavioural Expectations:</strong>' +
      suspension.behaviourExpectations;
  }

  return content;
}
